import template from "./info.html";
import {infoController} from "./info.controller";

export const infoComponent = {
	template,
	controller: infoController,
	controllerAs: "info",
	bindings: {
		resolve: "<",
		close: "&",
		dismiss: "&",
		data: "<"
	}
};




// WEBPACK FOOTER //
// ./sources/utility/info/info.component.js